import { connect } from 'react-redux';
import StatusCode from './pages';

const mapStateToProps = (state) => {
    return {
        ...state
    }
};

export default connect(mapStateToProps)(StatusCode);